import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=439e2d2a&"
import script from "./Comments.vue?vue&type=script&lang=js&"
export * from "./Comments.vue?vue&type=script&lang=js&"
import style0 from "./Comments.vue?vue&type=style&index=0&id=439e2d2a&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('439e2d2a')) {
      api.createRecord('439e2d2a', component.options)
    } else {
      api.reload('439e2d2a', component.options)
    }
    module.hot.accept("./Comments.vue?vue&type=template&id=439e2d2a&", function () {
      api.rerender('439e2d2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chat/Comments.vue"
export default component.exports